<template>
  <div id="contenedor-main-contrato-avances-expediente">
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <template v-if="getListadoDocumentosPresentacion.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay avances registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-card
      flat>
      <v-card-text :class="$vuetify.breakpoint.xs ? 'px-0 mx-0' : ''">
        <listado
          v-if="!$apollo.loading && getListadoDocumentosPresentacion.length > 0"
          :listadoDocumentosPresentacion="getListadoDocumentosPresentacion">
        </listado>
      </v-card-text>
    </v-card>
    </template>
    <v-dialog
      v-if="esteDocumentoExpediente"
      v-model="mostrarVerDocumentoExpediente"
      width="1200"
      :fullscreen="this.$vuetify.breakpoint.xs"
      scrollable>
      <v-card>
        <v-card-title class="secondary--text">
          Vista de PDF
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarVentana">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ver-documento-pdf
          :documentoPdfVer="esteDocumentoExpediente"
          v-on:cerrar="cerrarVentana"
          vistaSimple
        />
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarVentana"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EXPEDIENTE_POR_CONTRATO from '@/graphql/querys/administracion/expediente/expedientePorContrato.gql';
import VerDocumentoPdf from '@/components/VistaDocumentoPdf.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoAvancesExpediente',
  components: {
    Listado,
    VerDocumentoPdf,
    CustomButton,
  },
  data() {
    return {
      mostrarVerDocumentoExpediente: false,
      esteDocumentoExpediente: null,
    };
  },
  apollo: {
    expedientePorContrato: {
      query: EXPEDIENTE_POR_CONTRATO,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarVerDocumentoExpediente = false;
      this.esteDocumentoExpediente = null;
    },
  },
  computed: {
    getExpedientePorContrato() {
      if (!this.expedientePorContrato) return [];
      return this.expedientePorContrato;
    },
    // obtengo los documentos del tipo presentacion.
    getListadoDocumentosPresentacion() {
      return this.getExpedientePorContrato
        .filter((expediente) => expediente.documento.tipoDocumento.descripcion === 'PRESENTACIONES' && expediente.publicKey);
    },
  },
  mounted() {
    eventBus.$on('ver-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarVerDocumentoExpediente = true;
    });
  },
};
</script>

<style lang="scss">

</style>
